import script from "./tianbaorizhi.vue?vue&type=script&setup=true&lang=js"
export * from "./tianbaorizhi.vue?vue&type=script&setup=true&lang=js"

import "./tianbaorizhi.vue?vue&type=style&index=0&id=6a8bada0&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a8bada0"]])

export default __exports__